module.exports = __webpack_public_path__ + "static/img/Mudanza.f37bc324.png";